// import idx from "idx";
// import validation from "@utilities/validation/regex";

import idx from "idx";
import validation from "@utilities/validation/regex";

const newsletterConstraints = (customValidationMessages) => ({
  dwfrm_register_privacyTerms: {
    presence: {
      allowEmpty: false
    }
  },
  dwfrm_register_profile_customer_subscribe: {
    presence: {
      allowEmpty: false
    },
  },
  dwfrm_newsletter_email: {
    email: true,
    presence: {
      allowEmpty: false
    },
    length: {
      ...idx(customValidationMessages, (_) => _.dwfrm_profile_customer_email.length),
      maximum: 50,
    }
  },
  dwfrm_newsletter_companyName: {
    presence: {
      allowEmpty: false
    },
    length: {
      ...idx(customValidationMessages, (_) => _.dwfrm_profile_customer_email.length),
      maximum: 50,
    }
  },
  dwfrm_newsletter_firstname: {
    presence: {
      allowEmpty: false
    },
    format: {
      ...idx(customValidationMessages, (_) => _.dwfrm_profile_customer_firstname.format),
      pattern: validation.names,
    }
  },
  dwfrm_newsletter_lastname: {
    presence: {
      allowEmpty: false
    },
    format: {
      ...idx(customValidationMessages, (_) => _.dwfrm_profile_customer_lastname.format),
      pattern: validation.names,
    }
  },
  dwfrm_contact_country: {
    presence: {
      allowEmpty: false
    }
  }
});

export default newsletterConstraints;
